import { Dialog, DialogFooter } from "@fluentui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import {
  reportDocumentRoutine,
  setReportDocumentDialog,
} from "../../store/clients-page/clientsPage";
import { StyledPrimaryButton } from "../../components/styled";
import { FormSpinner } from "../../components/FormSpinner";
import { useSelector } from "../../store/hooks";

export const ReportDocumentDialog = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const isLoading = useSelector(
    (s) => s.clientsPage.reportDocumentLoadStatus === "loading"
  );
  const reportDocumentDialog = useSelector(
    (s) => s.clientsPage.reportDocumentDialog
  );
  const reportDocument = useSelector((s) => s.clientsPage.reportDocument);
  const close = () => {
    dispatch(
      setReportDocumentDialog({
        isOpen: false,
        clientId: null,
      })
    );
  };

  return (
    <Dialog
      hidden={false}
      dialogContentProps={{
        showCloseButton: true,
        title: t("ram.reportsDocument.label"),
      }}
      onDismiss={close}
    >
      {t("ram.clientReportDocumentDialogText.label")}
      <DialogFooter>
        {reportDocument !== null ? (
          <StyledPrimaryButton
            iconProps={{ iconName: "Download" }}
            text={t("ram.reportDocumentDialogDownload.label")}
            onClick={() => {
              window.open(reportDocument.url, "_blank");
              close();
            }}
          />
        ) : (
          <StyledPrimaryButton
            iconProps={{ iconName: "TextDocument" }}
            text={t("ram.reportDocumentDialogGenerate.label")}
            onClick={() => {
              dispatch(
                reportDocumentRoutine.trigger({
                  clientId: reportDocumentDialog.clientId,
                })
              );
            }}
            disabled={isLoading}
          />
        )}
      </DialogFooter>
      {isLoading && <FormSpinner />}
    </Dialog>
  );
};
